<template>
  <div>
    <h1>Create a New Post</h1>
    <form @submit.prevent="createPost">
      <div>
        <label for="title">Title:</label>
        <input type="text" id="title" v-model="title" required />
      </div>
      <div>
        <label for="content">Content:</label>
        <textarea id="content" v-model="content" required></textarea>
      </div>
      <button type="submit">Create Post</button>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "CreatePost",
  data() {
    return {
      title: "",
      content: "",
    };
  },
  methods: {
    async createPost() {
      try {
        const newPost = { title: this.title, content: this.content };
        await axios.post("http://localhost:5000/posts", newPost);
        this.$router.push("/posts"); // Redirect to posts list
      } catch (error) {
        console.error("Error creating post:", error);
      }
    },
  },
};
</script>
